import { impressions } from '../utils'

export default {
  methods: {
    formatImpressionsValue: impressions
  }
}
